import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	ModalController
} from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { MAddressModalPage } from "../maddress/maddress.modal";

@Component({
	selector: "modal-missingaddress",
	templateUrl: "./modal-missingaddress.html"
})
export class MissingAddressModalPage {
	selectedAddress: any = {};
	public mulitpleAddress = false;
	saveCustomerBtn = false;
	public m_all_district = [];
	public m_all_tehsil = [];
	public m_all_village = [];
	public all_pincode = [];
	public searchedPincode = null;

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public modalController: ModalController,
		public addOrderService: AddOrderServiceProvider,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
	) {}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {
		this.addOrderService.masterAddressId = null;
		this.addOrderService.newmissingAddress = false;

		this.addOrderService.missingAddressData.state = this.addOrderService.postData.state;
		this.addOrderService.missingAddressData.district = this.addOrderService.postData.district;
		this.addOrderService.missingAddressData.tehsil = this.addOrderService.postData.tehsil;
		this.addOrderService.missingAddressData.village = this.addOrderService.postData.village;
	}

	removeAddressPart(type) {
		if (type === "state") {
			this.addOrderService.missingAddressData.state = null;
			this.addOrderService.missingAddressData.district = null;
			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}

		if (type === "district") {
			this.addOrderService.missingAddressData.district = null;
			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}

		if (type === "tehsil") {
			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}

		if (type === "village") {
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}
	}

	openAddressModal(type_address) {
		let modalObject: any = {};

		if (
			type_address === "district" &&
			!this.addOrderService.missingAddressData.state
		) {
			return false;
		}

		if (
			type_address === "tehsil" &&
			(!this.addOrderService.missingAddressData.state ||
				!this.addOrderService.missingAddressData.district)
		) {
			return false;
		}

		if (
			type_address === "village" &&
			(!this.addOrderService.missingAddressData.state ||
				!this.addOrderService.missingAddressData.district ||
				!this.addOrderService.missingAddressData.tehsil)
		) {
			return false;
		}

		if (
			type_address === "pincode" &&
			(!this.addOrderService.missingAddressData.state ||
				!this.addOrderService.missingAddressData.district ||
				!this.addOrderService.missingAddressData.tehsil ||
				!this.addOrderService.missingAddressData.tehsil)
		) {
			return false;
		}

		modalObject = this.modalController.create(MAddressModalPage, {
			type: type_address
		});

		modalObject.present();
	}

	saveMissingAddress() {
		if (
			this.addOrderService.missingAddressData.state !== null &&
			this.addOrderService.missingAddressData.district != null &&
			this.addOrderService.missingAddressData.tehsil !== null &&
			this.addOrderService.missingAddressData.village !== null
		) {
			this.saveCustomerBtn = true;

			const ObjMissaddr = {
				state_name: this.addOrderService.missingAddressData.state.toUpperCase(),
				district_name: this.addOrderService.missingAddressData.district.toUpperCase(),
				tehsil_name: this.addOrderService.missingAddressData.tehsil.toUpperCase(),
				village_name: this.addOrderService.missingAddressData.village.toUpperCase(),
				pincode: this.addOrderService.missingAddressData.pincode,
				user_id: localStorage.getItem("user-id")
			};

			this.apiService
				.post("master-address", ObjMissaddr)
				.subscribe(result => {
					if (result["data"]["status"] == "error") {
						this.helperService.presentToast(
							result["data"]["message"]
						);

						if (result["data"]["address"]) {
							this.addOrderService.masterAddressId =
								result["data"]["address"]["master_address_id"];

							this.addOrderService.postData.district =
								result["data"]["address"]["district_name"];
							this.addOrderService.postData.state =
								result["data"]["address"]["state_name"];
							this.addOrderService.postData.tehsil =
								result["data"]["address"]["tehsil_name"];
							this.addOrderService.postData.village =
								result["data"]["address"]["village_name"];
							this.addOrderService.postData.pincode =
								result["data"]["address"]["pincode"];

							this.navCtrl.pop();
						}
					} else {
						this.addOrderService.masterAddressId =
							result["data"]["master_address_id"];

						this.addOrderService.postData.district =
							result["data"]["district_name"];
						this.addOrderService.postData.state =
							result["data"]["state_name"];
						this.addOrderService.postData.tehsil =
							result["data"]["tehsil_name"];
						this.addOrderService.postData.village =
							result["data"]["village_name"];
						this.addOrderService.postData.pincode =
							result["data"]["pincode"];

						this.addOrderService.newmissingAddress = true;

						this.navCtrl.pop();
					}

					this.saveCustomerBtn = false;
				});
		} else {
			this.saveCustomerBtn = false;
			this.helperService.presentToast(
				"State , District , Tehsil or Village cannot be empty"
			);
		}
	}

	getAddress(type_address, value) {
		this.addOrderService.missingAddressData[type_address] = value;

		if (type_address === "pincode") {
			return false;
		}

		let addressInfo: any = {};

		addressInfo.state_name = value;

		if (type_address === "state") {
			addressInfo.state_name = value;
			addressInfo.searchon = "district_name";

			this.addOrderService.missingAddressData.district = null;
			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}

		if (type_address === "district") {
			addressInfo.state_name = this.addOrderService.missingAddressData.state;
			addressInfo.district_name = this.addOrderService.missingAddressData.district;

			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;

			addressInfo.searchon = "tehsil_name";
		}

		if (type_address === "tehsil") {
			addressInfo.state_name = this.addOrderService.missingAddressData.state;
			addressInfo.district_name = this.addOrderService.missingAddressData.district;
			addressInfo.tehsil_name = this.addOrderService.missingAddressData.tehsil;

			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;

			addressInfo.searchon = "village_name";
		}

		if (type_address === "village") {
			addressInfo.state_name = this.addOrderService.missingAddressData.state;
			addressInfo.district_name = this.addOrderService.missingAddressData.district;
			addressInfo.tehsil_name = this.addOrderService.missingAddressData.tehsil;
			addressInfo.village_name = this.addOrderService.missingAddressData.village;

			this.addOrderService.missingAddressData.pincode = null;

			addressInfo.searchon = "pincode";
		}

		this.apiService
			.post("customer/address/info", addressInfo)
			.subscribe(response => {
				var result = response["data"];

				if (type_address === "state") {
					this.addOrderService.m_all_district = [];
					this.addOrderService.m_all_district = result;
				}

				if (type_address === "district") {
					this.addOrderService.m_all_tehsil = [];
					this.addOrderService.m_all_tehsil = result;
				}

				if (type_address === "tehsil") {
					this.addOrderService.m_all_village = [];
					this.addOrderService.m_all_village = result;
				}
			});
	}

	removeAddress() {
		this.addOrderService.missingAddressData.state = null;
		this.addOrderService.missingAddressData.district = null;
		this.addOrderService.missingAddressData.tehsil = null;
		this.addOrderService.missingAddressData.village = null;
		this.addOrderService.missingAddressData.pincode = null;
	}
}



// WEBPACK FOOTER //
// ./src/modals/missingaddress/missingaddress.modal.ts